import { GetterTree } from "vuex";
import { RecoveryState } from "./state";

export const getters: GetterTree<RecoveryState, any> = {
  getSearchResults: (state) => state.searchResults || [],
  isSearching: (state) => !!state.isSearching,
  getAuditLogs: (state) => state.auditLogs || [],
};
